module.exports = __webpack_public_path__ + "static/media/spreadsheet-add-white.50545f46.svg";